// Sends a freshly opened app to its own picker, so a new shift chooses where it is
// working instead of inheriting the last shift's choice and quietly tagging leads to
// the wrong place, or admitting people to the wrong room.
//
// Which picker depends on what the phone is for: a partner's phone picks a sponsored
// area, one of ours on a door picks the workshop it is standing outside.
//
// Done here rather than by clearing the stored area on startup. Clearing on every
// load left the scanner unreachable after any stray reload.

// Cleared only when the app itself is loaded again, which is what makes this the
// app opening rather than a move between screens.
let asked = false

export default defineNuxtRouteMiddleware((to) => {
  if (asked) {
    return
  }

  asked = true

  const device = useScanDevice()

  // An unpaired phone belongs on the setup screen whatever it was asked for.
  if (!device.value.provisioned) {
    return to.path === '/' ? undefined : navigateTo('/')
  }

  const picker = scanDeviceHome(device.value.purpose)

  if (to.path !== picker) {
    // Dropped here rather than on startup, keeping a stale area or room out of the
    // header while the shift chooses.
    device.value.areaId = null
    device.value.areaName = ''
    device.value.sessionId = null
    device.value.sessionTitle = ''
    device.value.sessionRoom = ''
    device.value.sessionDate = ''
    device.value.sessionTime = ''

    return navigateTo(picker)
  }
})
